import {
  NOTIFICATION_DATA,
  NOTIFICATION_GET_DATA,
  NOTIFICATION_FORM_ADD_DATA,
  NOTIFICATION_UPDATE_DATA,
  NOTIFICATION_DELETE_DATA,
  NOTIFICATION_AUDIT_GET_DATA,
 
} from "./Constants";
const initialState = {
  loading: false,
  error: null,
  notification: {},
  notify: {},
  mynotify: {},
  audit: [],
  audits: [],
};
const Reducer = (state = initialState, action) => {
  switch (action.type) {

      //load all notification
    case NOTIFICATION_DATA.NOTIFICATION_DATA_LOAD:
      return {
        ...state,
        loading: true,
        notification: {},
        error: null,
      };
    case NOTIFICATION_DATA.NOTIFICATION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        notification: {data: action.notification,},
      };
    case NOTIFICATION_DATA.NOTIFICATION_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      //Get Noti by id
    case NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        notify: {},
        error: null,
      };
    case NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        notify: action.notify,
        error: null,
      };
    case NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        notify: {},
        error: action.error,
      };
      //Get audit data by id
    case NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        audit: {},
        error: null,
      };
    case NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        audit: action.audit,                
        error: null,
      };
    case NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        audit: {},
        error: action.error,
      };
      // Add noti
    case NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        mynotify: {},
        error: null,
      };
    case NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        mynotify: action.mynotify,
        error: null,
      };
    case NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        mynotify: {},
        error: action.error,
      };
      // Update 
    case NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_LOAD:
            return {
                ...state,
                loading: true,
                error: null
            }
        case NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                mynotify: action.mynotify,
                error: false
            }
        case NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            }
      // Delete Noti
    case NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_LOAD:
      return {
        ...state,
        loading: true,
        notify: {},
        error: null,
      };
    case NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        notify: action.notify,
        error: null,
      };
    case NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        notify: {},
        error: action.error,
      };       
    
    default:
      return {
        ...state,
      };
  }
};
export default Reducer;
